import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface RemoveInvoiceDialogData {
  invoice: any;
  patient: any;
  group: any;
  user: any;
  hasPayments?: boolean;
  paymentDetails?: any[];
}

export interface RemoveInvoiceDialogResult {
  action: 'remove' | 'removeAndRecreate' | 'removeWithPayments' | 'removeWithPaymentsAndRecreate' | 'testPrefill' | 'cancel';
  reason: string;
  removePayments?: boolean;
}

@Component({
  selector: 'app-remove-invoice-dialog',
  templateUrl: './remove-invoice-dialog.component.html',
  styleUrls: ['./remove-invoice-dialog.component.scss']
})
export class RemoveInvoiceDialogComponent {
  form: FormGroup;
  selectedAction: 'remove' | 'removeAndRecreate' | 'removeWithPayments' | 'removeWithPaymentsAndRecreate' | 'cancel' = 'remove';

  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    public dialogRef: MatDialogRef<RemoveInvoiceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RemoveInvoiceDialogData
  ) {
    this.form = this.fb.group({
      reason: ['', [Validators.required, Validators.minLength(10)]],
      action: ['remove', [Validators.required]]
    });
    
     }

  onActionChange(event: any) {
    this.selectedAction = event.value;
    this.form.patchValue({ action: event.value });
    this.cdr.detectChanges();
  }

  get hasPayments(): boolean {
    return this.data.hasPayments || false;
  }

  get paymentTotal(): number {
    if (!this.data.paymentDetails) return 0;
    return this.data.paymentDetails.reduce((sum, payment) => sum + (payment.allocatedAmount || 0), 0);
  }

  get isDangerousAction(): boolean {
    const action = this.form.get('action')?.value;
    return action === 'removeWithPayments' || action === 'removeWithPaymentsAndRecreate';
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    if (this.form.valid) {
      const actionValue = this.form.get('action')?.value;
      const result: RemoveInvoiceDialogResult = {
        action: actionValue,
        reason: this.form.get('reason')?.value,
        removePayments: actionValue === 'removeWithPayments' || actionValue === 'removeWithPaymentsAndRecreate'
      };
      this.dialogRef.close(result);
    }
  }

  onTestPrefill(): void {
    // Create a test result for prefill testing
    const testResult: RemoveInvoiceDialogResult = {
      action: 'testPrefill',
      reason: this.form.get('reason')?.value || 'Test prefill functionality',
      removePayments: false
    };
    
    // Close the dialog with the test result
    this.dialogRef.close(testResult);
  }

  get isFormValid(): boolean {
    const actionValue = this.form.get('action')?.value;
    return this.form.valid && actionValue !== 'cancel';
  }
}
